import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const ArrowDown = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Down arrow",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      focusable="false"
      role={decorative ? "presentation" : "img"}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path d="M12 15.2 6.4 9.6l.7-.8 4.9 4.9 4.9-4.9.7.8-5.6 5.6Z" />
    </svg>
  );
};

